// Interceptor de autenticación — agrega el token y sessionId a cada request
import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { API_ENDPOINTS } from '../config/api.config';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  // Evita recursión cuando se solicita/renueva token.
  if (req.url === API_ENDPOINTS.auth.token || req.url === API_ENDPOINTS.auth.refresh) {
    return next(req);
  }

  // Si el token es válido, adjuntarlo directamente
  if (authService.isTokenValid()) {
    return next(attachAuthHeaders(req, authService));
  }

  // Si no hay token válido, obtener uno nuevo antes de continuar
  return authService.fetchToken().pipe(
    switchMap(() => next(attachAuthHeaders(req, authService))),
  );
};

/** Adjunta los headers de autorización al request */
function attachAuthHeaders(
  req: HttpRequest<unknown>,
  authService: AuthService,
): HttpRequest<unknown> {
  const token = authService.getAccessToken();
  const sessionId = authService.getSessionId();

  if (!token) return req;

  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  };

  if (sessionId) {
    headers['X-Session-Id'] = sessionId;
  }

  return req.clone({ setHeaders: headers });
}
